var map = {
	"./emoji-1.png": "2c1c",
	"./emoji-10.png": "7630",
	"./emoji-11.png": "c630",
	"./emoji-12.png": "736b",
	"./emoji-13.png": "609b",
	"./emoji-14.png": "668a",
	"./emoji-15.png": "0966",
	"./emoji-16.png": "70ce",
	"./emoji-17.png": "cb00",
	"./emoji-18.png": "d343",
	"./emoji-19.png": "e144",
	"./emoji-2.png": "0772",
	"./emoji-20.png": "8610",
	"./emoji-21.png": "ad20",
	"./emoji-22.png": "bbe7",
	"./emoji-23.png": "d967",
	"./emoji-24.png": "10b4",
	"./emoji-25.png": "cc07",
	"./emoji-26.png": "ff6b",
	"./emoji-27.png": "2460",
	"./emoji-28.png": "6b9b",
	"./emoji-29.png": "045c",
	"./emoji-3.png": "2777",
	"./emoji-30.png": "711d",
	"./emoji-31.png": "3f54",
	"./emoji-32.png": "9572",
	"./emoji-33.png": "2c63",
	"./emoji-34.png": "eeb9",
	"./emoji-35.png": "b904",
	"./emoji-36.png": "849f",
	"./emoji-37.png": "7f83",
	"./emoji-38.png": "209c",
	"./emoji-39.png": "3054",
	"./emoji-4.png": "0442",
	"./emoji-40.png": "d627",
	"./emoji-41.png": "b74c",
	"./emoji-42.png": "5992",
	"./emoji-43.png": "202c",
	"./emoji-44.png": "69a6",
	"./emoji-45.png": "29ec",
	"./emoji-46.png": "1723",
	"./emoji-47.png": "850d",
	"./emoji-48.png": "39f9",
	"./emoji-49.png": "f950",
	"./emoji-5.png": "dbae",
	"./emoji-50.png": "69e4",
	"./emoji-51.png": "8760",
	"./emoji-52.png": "231c",
	"./emoji-53.png": "32a5",
	"./emoji-54.png": "8333",
	"./emoji-55.png": "058f",
	"./emoji-56.png": "62d3",
	"./emoji-57.png": "43ef",
	"./emoji-58.png": "77f0",
	"./emoji-59.png": "146e",
	"./emoji-6.png": "b02d",
	"./emoji-60.png": "97c0",
	"./emoji-61.png": "f7f0",
	"./emoji-62.png": "85ea",
	"./emoji-63.png": "8699",
	"./emoji-64.png": "5e52",
	"./emoji-7.png": "881c",
	"./emoji-8.png": "fd30",
	"./emoji-9.png": "c14b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04ca";